module.exports = __webpack_public_path__ + "img/Grace-Hopper.0f2febc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Grace-Hopper.png
// module id = wzhH
// module chunks = 1